import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable } from 'rxjs';
import { BulkDocAddPayload } from '../models/review/bulk-doc-add-payload.model';

@Injectable({
	providedIn: 'root'
})
export class EmailFamilySdk extends SdkBase {
	constructor(injector: Injector) {
		super(injector);
	}

	public getEmailFamilyDocCountByQuery(body: BulkDocAddPayload): Observable<number> {
		return this.makeHttpRequest<number>('post', 'api2/emailFamilies?$count=true', body);
	}
}
